module.exports = __webpack_public_path__ + "img/sleeve cuff width.229faa09.png";